
import React, { useContext, useEffect, useState } from 'react';
import { SocketContext } from '../socket/SocketContext';
import { formatDistanceToNow } from 'date-fns';
import "./Header.css";
import Dropdown from "react-bootstrap/Dropdown";
import usericon from "../images/user-icon.svg";
import logouticon from "../images/logout-icon.svg";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import { BsBell } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userlogout } from "../public/Signin/loginSlice";
import { getPatientDetailsById } from '../services/pushNotificationService';
import { fetchNotifications, markNotificationAsRead, markSingleNotificationAsRead } from '../public/chat/notificationsSlice';
const capitalizeWords = (str) => {
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

function HeaderComponent() {

  const title = useSelector((state) => state?.sideBar?.data);
  const { data } = useSelector((state) => state.login);
  const socket = useContext(SocketContext);
  const { loading, notificationData, error } = useSelector((state) => state.notifications);
  const inputString = `${data.firstName} ${data.lastName}`;
  const capitalizedString = capitalizeWords(inputString);

  const userDataString = localStorage.getItem("user");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPanel, setShowPanel] = useState(false);
  const togglePanel = () => {
    setShowPanel((prevState) => !prevState);
  };


  useEffect(() => {
    // Fetch initial notifications
    if (socket) {
      socket?.emit('join-globaly', data._id)

    }
    dispatch(fetchNotifications(data._id));
    socket?.on('received-notification', (notification) => {
      if (notification)
        dispatch(fetchNotifications(data._id));
    });
  }, [socket])



  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.clear();
    dispatch(userlogout());
    navigate("/signin");
  };

  const redirectToProfile = async () => {
    const userData = JSON.parse(userDataString);
    data.role == "DOCTOR" || data.role == "PROVIDER" ? navigate("/doctor/profile", { state: { provider: data?._id } }) : navigate("/admin/profile", { state: { provider: data?._id } })

  };
  let patient;

  const redirectToChat = async (patientId, notificationId) => {
    setShowPanel(false);

    await dispatch(markNotificationAsRead({ userId: data._id, patientId: patientId }))
    dispatch(fetchNotifications(data._id));
    patient = await getPatientDetailsById(patientId)


    if (data.role === "ADMIN") {
      navigate("/admin/patient", {
        state: {
          patient: {
            ...patient.data,
            _id: patientId,
          },
          activeTabFromSate: "chat",
        },
      });
    } else if (data.role === "DOCTOR") {
      navigate("/doctor/patient", {
        state: {
          patient: {
            ...patient.data,
            _id: patientId,
          },
          activeTabFromSate: "chat",
        },
      });
    }

  }



  const redirectToSurvey = async (patientId, notificationId) => {
    setShowPanel(false);

    dispatch(markSingleNotificationAsRead(notificationId))
    dispatch(fetchNotifications(data._id));
    if (data.role === "ADMIN") {
      navigate("/admin/survey/survey-list");
    } else if (data.role === "DOCTOR") {
      navigate("/doctor/survey/survey-list");
    }

  }

  const colors = [

    // "#66D4CF", // Mint
    // "#FFD60A", //  Yellow
    // "#40C8E0", // Teal
    // "#BF5AF2", // Purple
    "#64D2FF", // Cyan
    // "#E9E976", //   light yellow
    // "#5E5CE6", // Indigo
    //  "#e9c183", // light Orange
  ];



  return (
    <>
      <div className="dashboard-header d-flex justify-content-between flex-wrap">
        <h2 className="m-0">{title}</h2>
        <div className="header-content d-flex gap-3">
          <div className="notify-blk" onClick={togglePanel}  >
            <Button variant="primary ">
              <BsBell className="notification" />
            </Button>
            {notificationData?.length > 0 && <Badge>{notificationData?.length}</Badge>}
            <span className="visually-hidden">unread messages</span>
          </div>
          <div className="profileinfo-header">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic" className="d-flex p-0">
                {/* <img src={profileheader} alt="pic"></img> */}
                <div
                  className="patient-initials" style={{ background: colors[0] }}

                >
                  {`${data?.firstName?.[0] || ""}${data?.lastName?.[0] || ""
                    }`.toUpperCase()}
                </div>
                <p>
                  {data.role == "DOCTOR" || data.role == "PROVIDER" ? "Dr." : ""}  {capitalizedString}<br />
                  <span>{data.role == "DOCTOR" || data.role == "PROVIDER" ? "Doctor" : "Admin"}</span>
                </p>
              </Dropdown.Toggle>

              <Dropdown.Menu id='profile-dropdown'>
                <Dropdown.Item className="d-flex" onClick={redirectToProfile}>
                  <div className="dd-icons">
                    {" "}
                    <img src={usericon}></img>
                  </div>{" "}
                  Profile
                </Dropdown.Item>
                {/* <Dropdown.Item className="d-flex">
                  <div className="dd-icons">
                    {" "}
                    <img src={settingicon}></img>
                  </div>
                  Settings
                </Dropdown.Item> */}
                <Dropdown.Item className="d-flex" onClick={handleLogout}>
                  {" "}
                  <div className="dd-icons">
                    {" "}
                    <img src={logouticon}></img>
                  </div>{" "}
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>

      {showPanel && (
        <div className="notification-popup">
          <div className="notification-header">
            <h5>Notifications</h5>
            <button className="close-btn" onClick={togglePanel}>
              &times;
            </button>
          </div>
          <div className="notification-body">
            {notificationData?.length ? (
              <ul className="notification-list">
                {notificationData.map(
                  (notification, index) =>
                    !notification.isRead && (
                      <li
                        key={index}
                        className="notification-item"
                        onClick={() => {
                          notification?.type == "chat" && (redirectToChat(notification.from_id, notification._id))
                          notification?.type == "survey" && (redirectToSurvey(notification.from_id, notification._id))
                        }
                        }
                      >
                        <div className="notification-content">
                          {
                            notification?.type == "chat" && (
                              <div className="notification-text">
                                New Message from{" "}
                                <strong>
                                  {notification?.fromDetails?.firstName}{" "}
                                  {notification?.fromDetails?.lastName}
                                </strong>
                              </div>
                            )
                          }

                          {
                            notification?.type == "survey" && (
                              <div className="notification-text">
                                Dr.  {" "}
                                <strong>

                                  {notification?.fromDetails?.firstName}{" "}
                                  {notification?.fromDetails?.lastName}
                                </strong>
                                {" "} has created a new survey
                              </div>
                            )
                          }

                          <div className="notification-time">
                            {formatDistanceToNow(notification.sentAt, { addSuffix: true })}
                          </div>
                        </div>
                      </li>
                    )
                )}
              </ul>

            ) : (
              <p>No notifications available.</p>
            )}

          </div>
        </div>
      )}
    </>
  );
}

export default React.memo(HeaderComponent);
